/**
 * @generated SignedSource<<a42da004fe707d70f5ca56f91fd7f24f>>
 * @relayHash 7238294bac8d5857c56c3c4ea7c78b36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e07f6094c93b3b1c879faf4cc355f0fb438eb7906e827c5ff0dcff14366a812

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PublicLinkPageStatus = "BLOCKED_BY_CLASSIFICATION_LEVEL" | "BLOCKED_BY_CONTAINER_POLICY" | "BLOCKED_BY_ORG" | "BLOCKED_BY_PRODUCT" | "BLOCKED_BY_SPACE" | "OFF" | "ON" | "SITE_BLOCKED" | "SITE_DISABLED" | "SPACE_BLOCKED" | "SPACE_DISABLED" | "%future added value";
export type preloadShareAndRestrictButtonQuerySpaceOverviewQuery$variables = {
  cloudId: string;
  spaceKey: string;
};
export type preloadShareAndRestrictButtonQuerySpaceOverviewQuery$data = {
  readonly confluence_publicLinkSpaceHomePage: {
    readonly pageId: string;
    readonly pageStatus: PublicLinkPageStatus;
  } | null | undefined;
  readonly spaceHomepage: {
    readonly hasInheritedRestrictions: boolean;
    readonly hasRestrictions: boolean;
    readonly hasViewRestrictions: boolean;
    readonly id: string | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
};
export type preloadShareAndRestrictButtonQuerySpaceOverviewQuery = {
  response: preloadShareAndRestrictButtonQuerySpaceOverviewQuery$data;
  variables: preloadShareAndRestrictButtonQuerySpaceOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v2 = [
  {
    "args": [
      (v1/*: any*/)
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "spaceHomepage",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "hasInheritedRestrictions"
      },
      {
        "kind": "ScalarField",
        "name": "hasRestrictions"
      },
      {
        "kind": "ScalarField",
        "name": "hasViewRestrictions"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      (v1/*: any*/)
    ],
    "concreteType": "PublicLinkPage",
    "kind": "LinkedField",
    "name": "confluence_publicLinkSpaceHomePage",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "pageId"
      },
      {
        "kind": "ScalarField",
        "name": "pageStatus"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7238294bac8d5857c56c3c4ea7c78b36",
    "id": "3e07f6094c93b3b1c879faf4cc355f0fb438eb7906e827c5ff0dcff14366a812",
    "metadata": {},
    "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
    "operationKind": "query",
    "text": "query preloadShareAndRestrictButtonQuerySpaceOverviewQuery($cloudId:ID!,$spaceKey:String!){spaceHomepage(spaceKey:$spaceKey){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},confluence_publicLinkSpaceHomePage(cloudId:$cloudId,spaceKey:$spaceKey)@optIn(to:\"AskInCcApiPlatformBeforeUsing\"){pageId,pageStatus}}"
  }
};
})();

(node as any).hash = "d2db11b68f255ee089316a1bfb1d4b92";

export default node;
